import React from 'react';
import { Text, Wrapper } from './styles';

interface Props {
  icon?: React.ReactNode;
  text: string;
  onClick?: () => void;
  className?: string;
  isPadding?: boolean;
}

const NavbarActionButton: React.FC<Props> = ({ icon, text, onClick, className, isPadding = false }) => (
  <Wrapper role='button' onClick={onClick} className={className} isPadding={isPadding}>
    {icon && <div className='icon-image'>{icon}</div>}
    <Text>{text}</Text>
  </Wrapper>
);

export default NavbarActionButton;
